<template>
  <div class="d-flex flex-row align-start">
    <div :class="labelClass">
      {{label}}
    </div>
    <img 
      src="@/assets/copy-outline.svg"
      class="align-self-center clickable pressable hideWhenPrinting mt-n2"
      v-clipboard:copy="label"/>
      <!-- v-clipboard:success="onCopy"
      v-clipboard:error="onError" -->
  </div>
</template>

<script>
  export default {
    name: 'Copyable',
    props: {
      labelClass: {
        type: String,
        default: 'formValue mr-2'
      },
      label: {
        type: String,
        default: ''
      }
    }
  }
</script>